import { CircularProgress } from '@renderer-ui-library/mui';
import classNames from 'classnames';
import { FC } from 'react';
import styles from './loaderOverlay.module.scss';

type Props = {
    show: boolean;
    className?: string;
};

export const LoaderOverlay: FC<Props> = props => {
    return (
        <div
            className={classNames(props.className, styles.overlay, {
                [styles.show]: props.show,
            })}
        >
            <div className={styles.loader}>
                <CircularProgress variant="indeterminate" color="primary" />
            </div>
        </div>
    );
};
